import { forwardRef, type InputHTMLAttributes } from 'react'
import { cn } from '@/lib/cn'

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        'w-full rounded-input bg-white/[.03] border border-border-strong text-text placeholder:text-subtle',
        'px-4 h-12 text-[15px] outline-none transition-all',
        'focus:border-gold focus:bg-white/[.05] focus:ring-2 focus:ring-gold/25',
        className
      )}
      {...props}
    />
  )
)
Input.displayName = 'Input'
